$(document).ready(function() {
	$('.js-autoclick').each(function() {
		setTimeout(() => this.click(), $(this).data('timer') * 1000);
	});
})